import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import {
  TeammoApi,
  normalize,
  // compilePaginationObject,
} from 'app/utils/redux/helpers';
import { receiptSchema, paymentEventSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
// import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/receipts/actions';
import { sagaActions as paymentEventSagaActions } from 'app/ducks/paymentEvents/actions';
import { ReceiptsActionTypes as types } from 'app/ducks/receipts/types';

function* createReceiptSaga(action): any {
  yield put(sagaActions.createReceiptPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).receipts.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, receiptSchema);

    yield put(sagaActions.createReceiptSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createReceiptFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updateReceiptSaga(action): any {
  yield put(sagaActions.updateReceiptPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).receipts.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, receiptSchema);

    yield put(sagaActions.updateReceiptSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateReceiptFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* getReceiptSaga(action): any {
  yield put(sagaActions.getReceiptPending());
  const [error, response] = yield (yield TeammoApi(yield select())).receipts.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, receiptSchema);
    // console.log('111111111');
    // console.log(response, normalizedResponse);
    // console.log('222222222');

    yield put(sagaActions.getReceiptSuccess(normalizedResponse));
    // if (!_.isEmpty(normalizedResponse.paymentEvent.id)) {
    //   const peNormalizedResponse = normalize(response, paymentEventSchema);
    //   yield put(
    //     yield paymentEventSagaActions.getPaymentEventSuccess(
    //       peNormalizedResponse,
    //     ),
    //   );
    // }
    return normalizedResponse.entities.receipts[normalizedResponse.result];
  }
  yield put(
    handleError(error, sagaActions.getReceiptFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

// function* getAllReceiptsSaga(action): any {
//   yield put(
//     sagaActions.getAllReceiptsPending(
//       action.payload.compile ? action.payload.pagination : {},
//     ),
//   );
//   yield put(loadingStart());

//   const paginationObject = action.payload.compile
//     ? compilePaginationObject(
//       yield select((state) => state.receipts.pagination),
//     )
//     : action.payload.pagination;

//   const [error, response] = yield TeammoApi(
//     yield select(),
//   ).receipts.list(paginationObject);

//   if (response) {
//     const normalizedResponse = normalize(response, receiptListSchema);

//     yield put(
//       sagaActions.getAllReceiptsSuccess(
//         normalizedResponse,
//         response.meta,
//       ),
//     );
//     yield put(loadingFinish());
//   } else {
//     yield put(
//       error,
//       sagaActions.getAllReceiptsFailed(_.isEmpty(error) ? {} : error.response.data.errors),
//     );
//   }
// }

/* ********************************* SAGA WATCHERS ********************************* */

function* createReceiptSagaWatcher(): any {
  yield takeEvery(types.CREATE_RECEIPT_REQUESTED, createReceiptSaga);
}

function* updateReceiptSagaWatcher(): any {
  yield takeLatest(types.UPDATE_RECEIPT_REQUESTED, updateReceiptSaga);
}

function* getReceiptSagaWatcher(): any {
  yield takeEvery(types.GET_RECEIPT_REQUESTED, getReceiptSaga);
}

// function* getAllReceiptsSagaWatcher(): any {
//   yield takeLatest(
//     types.GET_ALL_RECEIPTS_REQUESTED,
//     getAllReceiptsSaga,
//   );
// }

export default function* root(): any {
  yield all([
    createReceiptSagaWatcher(),
    updateReceiptSagaWatcher(),
    getReceiptSagaWatcher(),
    // getAllReceiptsSagaWatcher(),
  ]);
}
